import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const FishSymbol: IconNode = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M2 16s9-15 20-4C11 23 2 8 2 8' }]],
];

export default FishSymbol;
